// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__31W6r","column":"style_column__2Zmop","row":"style_row__1lPXt"};